<template>
  <div id="avatar">
    <v-row align="center" justify="center">
      <v-col cols="auto" align-self="end" lg="1" md="1">
        <v-avatar size="100" tile>
          <v-img  :src="img"></v-img>
        </v-avatar>
      </v-col>
      <v-col cols="8" lg="11" md="11" sm="8">
        <v-list-item color="rgba(0, 0, 0, .4)">
          <v-list-item-content>
            <v-list-item-subtitle>Welcome</v-list-item-subtitle>
            <v-list-item-title class="title">{{
              displayName
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item></v-col
      >
    </v-row>
  </div>
</template>

<script>


export default {
  name: "Avatar",
  props: ["img","displayName"],
  data: () => ({
  }),
  created() {
    // this.getLineLiff();
  },
  methods: {
  },
};
</script>